exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".aui .flags-container{position:relative;min-height:60px;margin-bottom:10px}.aui .flags-container .alert{overflow:hidden;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0;padding:15px}.aui .flags-container .alert p{word-break:break-all;margin:1em 0 2em}.aui .flags-container .alert h3,.aui .flags-container .alert h4{font-weight:600;line-height:130%}.aui .flags-container .alert h3{margin-bottom:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/_flags.scss
// module id = 132
// module chunks = 3